// import {
//   ArrowRight,
//   Check,
//   CheckCircle,
//   ChevronRight,
//   Download,
//   Edit3,
//   Lock,
//   Star,
// } from 'lucide-react';
// import { useEffect, useState } from 'react';

// // Custom animations CSS
// const CustomAnimations = () => {
//   return (
//     <style jsx global>{`
//       @keyframes fadeIn {
//         from {
//           opacity: 0;
//         }
//         to {
//           opacity: 1;
//         }
//       }

//       @keyframes fadeInUp {
//         from {
//           opacity: 0;
//           transform: translate3d(0, 20px, 0);
//         }
//         to {
//           opacity: 1;
//           transform: translate3d(0, 0, 0);
//         }
//       }

//       @keyframes subtlePulse {
//         0% {
//           opacity: 0.5;
//         }
//         50% {
//           opacity: 0.7;
//         }
//         100% {
//           opacity: 0.5;
//         }
//       }

//       @keyframes subtleFloat {
//         0% {
//           transform: translateY(0px);
//         }
//         50% {
//           transform: translateY(-5px);
//         }
//         100% {
//           transform: translateY(0px);
//         }
//       }

//       @keyframes gradientAnimation {
//         0% {
//           background-position: 0% 50%;
//         }
//         50% {
//           background-position: 100% 50%;
//         }
//         100% {
//           background-position: 0% 50%;
//         }
//       }

//       .animate-fadeIn {
//         animation: fadeIn 0.5s ease-in-out forwards;
//       }

//       .animate-fadeInUp {
//         animation: fadeInUp 0.7s ease-out forwards;
//       }

//       .animate-subtlePulse {
//         animation: subtlePulse 4s ease-in-out infinite;
//       }

//       .animate-subtleFloat {
//         animation: subtleFloat 5s ease-in-out infinite;
//       }

//       .animate-gradient {
//         animation: gradientAnimation 15s ease infinite;
//         background-size: 300% 300%;
//       }

//       .transition-fade {
//         transition: opacity 0.5s ease, transform 0.5s ease;
//       }

//       .transition-subtle {
//         transition: all 0.7s cubic-bezier(0.19, 1, 0.22, 1);
//       }

//       .bg-grid-pattern {
//         background-size: 40px 40px;
//         background-image: linear-gradient(
//             to right,
//             rgba(59, 130, 246, 0.07) 1px,
//             transparent 1px
//           ),
//           linear-gradient(to bottom, rgba(59, 130, 246, 0.07) 1px, transparent 1px);
//         background-color: rgba(249, 250, 251, 0.01);
//       }
//     `}</style>
//   );
// };

// const ResumeReadyLanding = () => {
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [activeTestimonial, setActiveTestimonial] = useState(0);
//   const [showScoreAnimation, setShowScoreAnimation] = useState(false);

//   // Handle scroll events for navbar transformation with smoother threshold
//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 10);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Auto-rotate testimonials with a longer interval for better reading
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
//     }, 8000);
//     return () => clearInterval(interval);
//   }, []);

//   // Trigger score animation with a more natural delay
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowScoreAnimation(true);
//     }, 2500);
//     return () => clearTimeout(timer);
//   }, []);

//   const testimonials = [
//     {
//       quote: 'I landed an interview at Google in just a week after using ResumeReady!',
//       author: 'Sarah K.',
//       position: 'Marketing Specialist',
//       company: 'Hired at Google',
//       avatar: '/api/placeholder/40/40',
//     },
//     {
//       quote: 'The score feedback helped me boost my resume from 65 to 94 in minutes.',
//       author: 'Mike T.',
//       position: 'Full-Stack Developer',
//       company: 'Hired at Microsoft',
//       avatar: '/api/placeholder/40/40',
//     },
//     {
//       quote: 'I applied to 5 jobs with my ResumeReady resume and got 3 interviews!',
//       author: 'Jessica L.',
//       position: 'Product Manager',
//       company: 'Hired at Amazon',
//       avatar: '/api/placeholder/40/40',
//     },
//   ];

//   return (
//     <div className='flex flex-col min-h-screen bg-background text-foreground font-sans antialiased'>
//       <CustomAnimations />

//       {/* Mobile CTA - Fixed at bottom */}
//       <div className='lg:hidden'>
//         <button className='fixed bottom-0 left-0 right-0 bg-background/95 backdrop-blur-sm border-t border-border z-50 py-3 px-4 w-full bg-primary text-primary-foreground rounded-none text-base font-medium hover:bg-primary/90 transition-all duration-300 ease-in-out shadow-md'>
//           Start Free Trial
//         </button>
//       </div>

//       {/* Navigation - transforms on scroll with refined animation */}
//       <nav
//         className={`py-4 border-b border-border/80 sticky top-0 z-10 transition-all duration-500 ease-in-out ${
//           isScrolled ? 'bg-background/90 backdrop-blur-sm shadow-sm' : 'bg-background'
//         }`}>
//         <div className='container mx-auto px-4 flex justify-between items-center'>
//           <div className='flex items-center space-x-2'>
//             <div className='h-10 w-10 rounded-md bg-primary flex items-center justify-center transition-transform duration-300 ease-in-out hover:scale-105'>
//               <span className='text-primary-foreground font-bold'>RS</span>
//             </div>
//             <span className='font-bold text-xl'>ResumeReady</span>
//           </div>
//           <div className='hidden lg:flex items-center space-x-8'>
//             <a
//               href='#features'
//               className='text-base hover:text-primary transition-colors relative group'>
//               Features
//               <span className='absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full'></span>
//             </a>
//             <a
//               href='#how-it-works'
//               className='text-base hover:text-primary transition-colors relative group'>
//               How It Works
//               <span className='absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full'></span>
//             </a>
//             <a
//               href='#pricing'
//               className='text-base hover:text-primary transition-colors relative group'>
//               Pricing
//               <span className='absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full'></span>
//             </a>
//             <a
//               href='#testimonials'
//               className='text-base hover:text-primary transition-colors relative group'>
//               Success Stories
//               <span className='absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full'></span>
//             </a>
//           </div>
//           <div>
//             <button className='hidden lg:block bg-secondary text-secondary-foreground rounded-md px-4 py-2 text-sm font-medium transition-all duration-300 ease-in-out hover:bg-secondary/90'>
//               Sign In
//             </button>
//             <button className='lg:hidden'>
//               <svg
//                 xmlns='http://www.w3.org/2000/svg'
//                 width='24'
//                 height='24'
//                 viewBox='0 0 24 24'
//                 fill='none'
//                 stroke='currentColor'
//                 strokeWidth='2'
//                 strokeLinecap='round'
//                 strokeLinejoin='round'>
//                 <line x1='4' x2='20' y1='12' y2='12' />
//                 <line x1='4' x2='20' y1='6' y2='6' />
//                 <line x1='4' x2='20' y1='18' y2='18' />
//               </svg>
//             </button>
//           </div>
//         </div>
//       </nav>

//       {/* Hero Section with Animation and Grid Background */}
//       <section className='py-16 md:py-24 container mx-auto px-4 overflow-hidden relative'>
//         {/* Grid Background with gradient spots */}
//         <div className='absolute inset-0 -z-10'>
//           <div className='absolute inset-0 bg-grid-pattern'></div>
//           <div className='absolute top-[20%] left-[15%] w-64 h-64 bg-blue-300/10 rounded-full filter blur-[80px]'></div>
//           <div className='absolute bottom-[20%] right-[15%] w-80 h-80 bg-blue-300/10 rounded-full filter blur-[100px]'></div>
//         </div>

//         <div className='grid lg:grid-cols-2 gap-12 items-center'>
//           <div className='space-y-6 max-w-xl'>
//             <div className='inline-flex items-center space-x-2 bg-primary/10 backdrop-blur-sm text-primary px-4 py-2 rounded-full text-sm font-medium animate-fadeIn'>
//               <Star size={16} className='text-primary' />
//               <span>Trusted by 10,000+ job seekers</span>
//             </div>

//             <h1 className='text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight transition-subtle'>
//               Land Your{' '}
//               <span className='text-primary relative animate-gradient bg-gradient-to-r from-primary via-chart-1 to-chart-4 text-transparent bg-clip-text'>
//                 Dream Job
//                 <span className='absolute -bottom-2 left-0 w-full h-1 bg-primary/30 rounded-full'></span>
//               </span>{' '}
//               with an ATS-Ready Resume
//             </h1>

//             <p className='text-xl text-muted-foreground'>
//               Create a professional, ATS-optimized resume in{' '}
//               <span className='font-bold'>under 10 minutes</span> — with our premium
//               tools.
//             </p>

//             <div className='flex flex-col sm:flex-row gap-4 pt-4'>
//               <button className='flex-1 bg-primary text-primary-foreground rounded-md px-6 py-4 text-lg font-medium transition-all duration-300 ease-in-out hover:bg-primary/90 hover:shadow-lg group'>
//                 <span className='flex items-center justify-center'>
//                   Start Free Trial
//                   <ArrowRight
//                     size={18}
//                     className='ml-2 transition-transform duration-300 ease-in-out group-hover:translate-x-1'
//                   />
//                 </span>
//               </button>

//               <button className='flex-1 border border-border bg-transparent text-foreground rounded-md px-6 py-4 text-lg font-medium transition-all duration-300 ease-in-out hover:bg-secondary/10 hover:border-secondary/50'>
//                 View Pricing
//               </button>
//             </div>

//             <div className='flex items-center space-x-4 pt-2'>
//               <div className='flex -space-x-2'>
//                 <div className='w-8 h-8 rounded-full bg-primary/20 border-2 border-background'></div>
//                 <div className='w-8 h-8 rounded-full bg-primary/30 border-2 border-background'></div>
//                 <div className='w-8 h-8 rounded-full bg-primary/40 border-2 border-background'></div>
//                 <div className='w-8 h-8 rounded-full bg-primary/50 border-2 border-background flex items-center justify-center text-xs font-medium'>
//                   +
//                 </div>
//               </div>
//               <p className='text-sm text-muted-foreground'>
//                 <span className='font-medium'>Join 500+ people</span> who subscribed this
//                 week
//               </p>
//             </div>
//           </div>

//           <div className='relative'>
//             <div className='absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-full filter blur-3xl -z-10 opacity-50 animate-subtlePulse'></div>

//             {/* Interactive Resume Preview */}
//             <div className='bg-card rounded-xl shadow-lg overflow-hidden border border-border p-6 transition-all duration-500 ease-in-out hover:shadow-xl hover:border-primary/20'>
//               <div className='flex justify-between items-center mb-6'>
//                 <h3 className='font-bold text-xl'>John Anderson</h3>
//                 <div
//                   className={`transition-all duration-700 ease-in-out flex items-center space-x-2 ${
//                     showScoreAnimation
//                       ? 'bg-green-400/10 text-green-400'
//                       : 'bg-primary/10 text-primary'
//                   } px-3 py-1 rounded-full text-sm font-medium`}>
//                   <span>Score: {showScoreAnimation ? '93' : '75'}</span>
//                   <span>/100</span>
//                   {showScoreAnimation && (
//                     <Check size={14} className='opacity-0 animate-fadeIn' />
//                   )}
//                 </div>
//               </div>

//               <div className='space-y-4'>
//                 <div>
//                   <h4 className='font-medium text-sm text-muted-foreground'>
//                     PROFESSIONAL SUMMARY
//                   </h4>
//                   <p className='mt-1 border border-border rounded-md p-3 bg-secondary/5 text-sm'>
//                     Senior Marketing Manager with{' '}
//                     <span
//                       className={`relative ${
//                         showScoreAnimation ? 'bg-green-400/10 text-green-400' : ''
//                       } transition-all duration-700 ease-out rounded px-1`}>
//                       7+ years of experience
//                     </span>{' '}
//                     driving growth through strategic digital campaigns and
//                     cross-functional team leadership.
//                   </p>
//                 </div>

//                 <div>
//                   <h4 className='font-medium text-sm text-muted-foreground'>
//                     EXPERIENCE
//                   </h4>
//                   <div className='mt-1 border border-border rounded-md p-3 bg-secondary/5 text-sm'>
//                     <div className='flex justify-between'>
//                       <p className='font-medium'>Marketing Director</p>
//                       <div className='text-xs px-2 py-0.5 bg-primary/10 text-primary rounded-full'>
//                         Current
//                       </div>
//                     </div>
//                     <p>TechCorp International • 2019 - Present</p>
//                     <ul className='mt-2 space-y-2 pl-5 list-disc'>
//                       <li>
//                         Led team of 8 marketers to achieve{' '}
//                         <span
//                           className={`relative ${
//                             showScoreAnimation ? 'bg-green-400/10 text-green-400' : ''
//                           } transition-all duration-700 ease-out rounded px-1`}>
//                           210% YoY growth
//                         </span>
//                       </li>
//                       <li
//                         className={`transition-all duration-700 ease-in-out ${
//                           showScoreAnimation ? 'bg-green-400/10' : 'bg-primary/5'
//                         } rounded p-1`}>
//                         {showScoreAnimation
//                           ? 'Increased quarterly revenue by $1.2M through data-driven campaigns'
//                           : 'Managed marketing budget effectively'}
//                       </li>
//                       <li>Launched 15 successful campaigns across digital platforms</li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>

//               {/* Interactive Elements - Refined animations */}
//               <div className='absolute -bottom-3 -right-3 bg-primary text-primary-foreground p-3 rounded-md shadow-md transition-all duration-500 ease-in-out hover:shadow-lg hover:bg-primary/90'>
//                 <Edit3 size={20} />
//               </div>

//               <div className='absolute top-16 right-6 transform translate-x-1/2 bg-primary/10 backdrop-blur-sm border border-primary/20 p-3 rounded-lg shadow-md text-sm opacity-0 hover:opacity-100 transition-opacity duration-500 ease-in-out'>
//                 <p className='text-xs font-medium text-primary mb-1'>ATS Tip</p>
//                 <p>Use specific metrics to showcase achievements</p>
//                 <div className='absolute left-0 top-1/2 -translate-x-2 -translate-y-1/2 w-2 h-2 bg-primary/10 transform rotate-45'></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Social Proof Banner */}
//       <section className='py-8 bg-secondary/5 border-y border-border/30'>
//         <div className='container mx-auto px-4'>
//           <div className='flex flex-wrap justify-between items-center gap-6'>
//             <p className='text-lg font-medium'>Trusted by professionals from:</p>
//             <div className='flex flex-wrap justify-center gap-8 opacity-70'>
//               <div className='h-8 flex items-center transition-subtle hover:opacity-100 hover:text-primary'>
//                 Google
//               </div>
//               <div className='h-8 flex items-center transition-subtle hover:opacity-100 hover:text-primary'>
//                 Microsoft
//               </div>
//               <div className='h-8 flex items-center transition-subtle hover:opacity-100 hover:text-primary'>
//                 Amazon
//               </div>
//               <div className='h-8 flex items-center transition-subtle hover:opacity-100 hover:text-primary'>
//                 Meta
//               </div>
//               <div className='h-8 flex items-center transition-subtle hover:opacity-100 hover:text-primary'>
//                 Apple
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Features Section with Proper Alignment */}
//       <section id='features' className='py-20'>
//         <div className='container mx-auto px-4'>
//           <div className='text-center max-w-2xl mx-auto mb-16'>
//             <div className='inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-4'>
//               <span>Why ResumeReady?</span>
//             </div>
//             <h2 className='text-3xl lg:text-4xl font-bold mb-4'>
//               Create a Resume That Gets You Hired
//             </h2>
//             <p className='text-lg text-muted-foreground'>
//               Our intelligent resume builder gives you the edge in today's competitive job
//               market
//             </p>
//           </div>

//           <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto'>
//             <div className='animate-fadeInUp' style={{ animationDelay: '0.1s' }}>
//               <FeatureCard
//                 icon={<Edit3 className='h-6 w-6' />}
//                 title='Professional Templates'
//                 description='Start with industry-tested templates designed to pass ATS systems and impress hiring managers.'
//                 color='bg-chart-1'
//               />
//             </div>

//             <div className='animate-fadeInUp' style={{ animationDelay: '0.2s' }}>
//               <FeatureCard
//                 icon={<Star className='h-6 w-6' />}
//                 title='Real-Time ATS Score'
//                 description='Know exactly how your resume performs against Applicant Tracking Systems before you apply.'
//                 color='bg-chart-2'
//               />
//             </div>

//             <div className='animate-fadeInUp' style={{ animationDelay: '0.3s' }}>
//               <FeatureCard
//                 icon={<Download className='h-6 w-6' />}
//                 title='Instant PDF Export'
//                 description='Download your perfectly formatted resume with one click—ready to send to employers.'
//                 color='bg-chart-3'
//               />
//             </div>

//             <div className='animate-fadeInUp' style={{ animationDelay: '0.4s' }}>
//               <FeatureCard
//                 icon={<CheckCircle className='h-6 w-6' />}
//                 title='AI-Powered Suggestions'
//                 description='Get smart recommendations to improve your content for each job description.'
//                 color='bg-chart-4'
//               />
//             </div>

//             <div className='animate-fadeInUp' style={{ animationDelay: '0.5s' }}>
//               <FeatureCard
//                 icon={<Lock className='h-6 w-6' />}
//                 title='Privacy First'
//                 description='Your data stays with you—we never share your information with third parties.'
//                 color='bg-chart-5'
//               />
//             </div>

//             <div className='animate-fadeInUp' style={{ animationDelay: '0.6s' }}>
//               <div className='bg-card border border-border rounded-lg p-8 transition-all duration-500 ease-in-out hover:shadow-md hover:border-primary/20 flex flex-col justify-between group h-full'>
//                 <div>
//                   <div className='inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary mb-4 transition-all duration-300 ease-in-out group-hover:scale-105'>
//                     <svg
//                       xmlns='http://www.w3.org/2000/svg'
//                       width='24'
//                       height='24'
//                       viewBox='0 0 24 24'
//                       fill='none'
//                       stroke='currentColor'
//                       strokeWidth='2'
//                       strokeLinecap='round'
//                       strokeLinejoin='round'>
//                       <path d='M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z' />
//                       <path d='m9 12 2 2 4-4' />
//                     </svg>
//                   </div>
//                   <h3 className='text-xl font-semibold mb-2'>Premium Support</h3>
//                   <p className='text-muted-foreground mb-6'>
//                     Get priority assistance from our resume experts with any premium plan.
//                   </p>
//                 </div>
//                 <button className='text-primary font-medium transition-all duration-300 ease-in-out group-hover:pl-1 flex items-center'>
//                   Learn More{' '}
//                   <ChevronRight
//                     size={16}
//                     className='ml-1 transition-transform duration-300 ease-in-out group-hover:translate-x-1'
//                   />
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* How It Works Section with Visual Flow */}
//       <section
//         id='how-it-works'
//         className='py-20 bg-secondary/5 relative overflow-hidden'>
//         <div className='absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-background to-transparent'></div>

//         {/* Subtle Grid Pattern like graph paper */}
//         <div className='absolute inset-0 -z-10'>
//           <div className='absolute inset-0 bg-grid-pattern'></div>
//           <div className='absolute bottom-[20%] left-[25%] w-64 h-64 bg-blue-300/10 rounded-full filter blur-[80px]'></div>
//         </div>

//         <div className='container mx-auto px-4'>
//           <div className='text-center max-w-2xl mx-auto mb-16'>
//             <div className='inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-4'>
//               <span>Simple Process</span>
//             </div>
//             <h2 className='text-3xl lg:text-4xl font-bold mb-4'>
//               From Demo to Done in Minutes
//             </h2>
//             <p className='text-lg text-muted-foreground'>
//               Three simple steps to create your professional resume
//             </p>
//           </div>

//           <div className='relative'>
//             {/* Connection line */}
//             <div className='hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-primary/20 -translate-y-1/2 z-0'></div>

//             <div className='grid lg:grid-cols-3 gap-12 relative z-10'>
//               <div className='animate-fadeInUp' style={{ animationDelay: '0.1s' }}>
//                 <StepCard
//                   number={1}
//                   title='Choose Your Template'
//                   description='Select from professionally designed templates tailored for your industry and role.'
//                   image='/api/placeholder/300/200'
//                 />
//               </div>

//               <div className='animate-fadeInUp' style={{ animationDelay: '0.3s' }}>
//                 <StepCard
//                   number={2}
//                   title='Customize & Optimize'
//                   description='Edit your content with our AI assistant and watch your ATS score improve in real-time.'
//                   image='/api/placeholder/300/200'
//                 />
//               </div>

//               <div className='animate-fadeInUp' style={{ animationDelay: '0.5s' }}>
//                 <StepCard
//                   number={3}
//                   title='Download & Apply'
//                   description='Export your polished resume as a PDF and start applying to your dream jobs today.'
//                   image='/api/placeholder/300/200'
//                 />
//               </div>
//             </div>
//           </div>

//           <div
//             className='mt-16 text-center animate-fadeInUp'
//             style={{ animationDelay: '0.7s' }}>
//             <button className='bg-primary text-primary-foreground rounded-md px-8 py-4 text-lg font-medium transition-all duration-300 ease-in-out hover:bg-primary/90 hover:shadow-lg group'>
//               <span className='flex items-center justify-center'>
//                 Start Your Free Trial
//                 <ArrowRight
//                   size={18}
//                   className='ml-2 transition-transform duration-300 ease-in-out group-hover:translate-x-1'
//                 />
//               </span>
//             </button>
//             <p className='mt-4 text-sm text-muted-foreground'>
//               7-day free trial • Cancel anytime
//             </p>
//           </div>
//         </div>
//         <div className='absolute bottom-0 left-0 w-full h-20 bg-gradient-to-t from-background to-transparent'></div>
//       </section>

//       {/* Auto-Rotating Testimonials */}
//       <section id='testimonials' className='py-20'>
//         <div className='container mx-auto px-4'>
//           <div className='text-center max-w-2xl mx-auto mb-12'>
//             <div className='inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-4'>
//               <span>Success Stories</span>
//             </div>
//             <h2 className='text-3xl lg:text-4xl font-bold mb-4'>
//               From Our Users to Top Companies
//             </h2>
//             <p className='text-lg text-muted-foreground'>
//               See how ResumeReady helped job seekers land interviews at leading companies
//             </p>
//           </div>

//           <div className='max-w-4xl mx-auto relative'>
//             <div className='relative h-64 bg-card border border-border rounded-xl p-8 shadow-lg overflow-hidden'>
//               {testimonials.map((testimonial, index) => (
//                 <div
//                   key={index}
//                   className={`absolute top-0 left-0 w-full h-full flex items-center p-8 transition-all duration-700 ease-in-out ${
//                     index === activeTestimonial
//                       ? 'opacity-100 translate-x-0'
//                       : index < activeTestimonial
//                       ? 'opacity-0 -translate-x-full'
//                       : 'opacity-0 translate-x-full'
//                   }`}>
//                   <div className='flex flex-col md:flex-row items-start gap-6'>
//                     <div className='flex-shrink-0'>
//                       <div className='w-16 h-16 rounded-full bg-primary/20 overflow-hidden border-2 border-primary/30'>
//                         <img
//                           src={testimonial.avatar}
//                           alt={testimonial.author}
//                           className='w-full h-full object-cover'
//                         />
//                       </div>
//                     </div>
//                     <div>
//                       <div className='flex mb-1'>
//                         {[1, 2, 3, 4, 5].map((star) => (
//                           <Star
//                             key={star}
//                             size={16}
//                             className='text-primary mr-1'
//                             fill='currentColor'
//                           />
//                         ))}
//                       </div>
//                       <p className='text-xl font-medium mb-4'>"{testimonial.quote}"</p>
//                       <div>
//                         <p className='font-bold'>{testimonial.author}</p>
//                         <p className='text-sm text-muted-foreground'>
//                           {testimonial.position} • {testimonial.company}
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}

//               <div className='absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2'>
//                 {testimonials.map((_, index) => (
//                   <button
//                     key={index}
//                     onClick={() => setActiveTestimonial(index)}
//                     className={`h-2 rounded-full transition-all duration-500 ease-in-out ${
//                       index === activeTestimonial
//                         ? 'bg-primary w-8'
//                         : 'bg-primary/30 w-2 hover:bg-primary/50'
//                     }`}
//                     aria-label={`View testimonial ${index + 1}`}
//                   />
//                 ))}
//               </div>
//             </div>
//           </div>

//           <div className='mt-16 text-center'>
//             <p className='text-2xl font-medium mb-6'>
//               Join 10,000+ successful job seekers today
//             </p>
//             <button className='bg-primary text-primary-foreground rounded-md px-8 py-4 text-lg font-medium transition-all duration-300 ease-in-out hover:bg-primary/90 hover:shadow-lg group'>
//               <span className='flex items-center justify-center'>
//                 Build My ATS-Optimized Resume
//                 <ArrowRight
//                   size={18}
//                   className='ml-2 transition-transform duration-300 ease-in-out group-hover:translate-x-1'
//                 />
//               </span>
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* Statistics Banner */}
//       <section className='py-12 bg-primary/5 border-y border-border/30'>
//         <div className='container mx-auto px-4'>
//           <div className='grid grid-cols-2 md:grid-cols-4 gap-8 text-center'>
//             <div className='animate-fadeInUp' style={{ animationDelay: '0.1s' }}>
//               <StatCard number='10,000+' label='Resumes Created' />
//             </div>
//             <div className='animate-fadeInUp' style={{ animationDelay: '0.2s' }}>
//               <StatCard number='85%' label='Interview Rate' />
//             </div>
//             <div className='animate-fadeInUp' style={{ animationDelay: '0.3s' }}>
//               <StatCard number='4.9/5' label='User Rating' />
//             </div>
//             <div className='animate-fadeInUp' style={{ animationDelay: '0.4s' }}>
//               <StatCard number='72%' label='Hired within 30 Days' />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Pricing Section */}
//       <section id='pricing' className='py-24 bg-secondary/5 relative overflow-hidden'>
//         <div className='absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-background to-transparent'></div>

//         {/* Subtle Grid Background like graph paper */}
//         <div className='absolute inset-0 -z-10'>
//           <div className='absolute inset-0 bg-grid-pattern'></div>
//           <div className='absolute top-[30%] right-[25%] w-48 h-48 bg-blue-300/10 rounded-full filter blur-[70px]'></div>
//         </div>

//         <div className='container mx-auto px-4'>
//           <div className='text-center max-w-2xl mx-auto mb-16'>
//             <div className='inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-4'>
//               <span>Affordable Plans</span>
//             </div>
//             <h2 className='text-3xl lg:text-4xl font-bold mb-4'>
//               Choose the Right Plan for Your Career
//             </h2>
//             <p className='text-lg text-muted-foreground'>
//               Invest in your future with our premium resume building tools
//             </p>
//           </div>

//           <div className='grid md:grid-cols-3 gap-8 max-w-5xl mx-auto'>
//             {/* Basic Plan */}
//             <div
//               className='bg-card border border-border rounded-xl overflow-hidden transition-all duration-500 ease-in-out hover:shadow-xl hover:border-primary/20 animate-fadeInUp'
//               style={{ animationDelay: '0.1s' }}>
//               <div className='p-6 border-b border-border'>
//                 <h3 className='text-xl font-bold mb-2'>Basic</h3>
//                 <div className='flex items-end mb-4'>
//                   <span className='text-4xl font-bold'>$9.99</span>
//                   <span className='text-muted-foreground ml-2 mb-1'>/month</span>
//                 </div>
//                 <p className='text-sm text-muted-foreground'>
//                   Perfect for new job seekers
//                 </p>
//               </div>
//               <div className='p-6'>
//                 <ul className='space-y-3'>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>3 professional templates</span>
//                   </li>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>Basic ATS compatibility check</span>
//                   </li>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>Unlimited PDF exports</span>
//                   </li>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>Email support</span>
//                   </li>
//                 </ul>
//                 <button className='w-full mt-6 bg-secondary text-secondary-foreground rounded-md px-4 py-3 text-sm font-medium transition-all duration-300 ease-in-out hover:bg-secondary/90'>
//                   Choose Basic
//                 </button>
//               </div>
//             </div>

//             {/* Pro Plan - Most Popular */}
//             <div
//               className='bg-card border-2 border-primary rounded-xl overflow-hidden transition-all duration-500 ease-in-out hover:shadow-xl relative animate-fadeInUp'
//               style={{ animationDelay: '0.2s' }}>
//               <div className='absolute top-0 inset-x-0 bg-primary text-primary-foreground text-center py-1 text-xs font-medium'>
//                 MOST POPULAR
//               </div>
//               <div className='p-6 border-b border-border pt-8'>
//                 <h3 className='text-xl font-bold mb-2'>Pro</h3>
//                 <div className='flex items-end mb-4'>
//                   <span className='text-4xl font-bold'>$19.99</span>
//                   <span className='text-muted-foreground ml-2 mb-1'>/month</span>
//                 </div>
//                 <p className='text-sm text-muted-foreground'>
//                   Ideal for active job hunters
//                 </p>
//               </div>
//               <div className='p-6'>
//                 <ul className='space-y-3'>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>10 premium templates</span>
//                   </li>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>Advanced ATS optimization</span>
//                   </li>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>AI-powered content suggestions</span>
//                   </li>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>Cover letter builder</span>
//                   </li>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>Priority email support</span>
//                   </li>
//                 </ul>
//                 <button className='w-full mt-6 bg-primary text-primary-foreground rounded-md px-4 py-3 text-sm font-medium transition-all duration-300 ease-in-out hover:bg-primary/90 shadow-sm'>
//                   Choose Pro
//                 </button>
//               </div>
//             </div>

//             {/* Premium Plan */}
//             <div
//               className='bg-card border border-border rounded-xl overflow-hidden transition-all duration-500 ease-in-out hover:shadow-xl hover:border-primary/20 animate-fadeInUp'
//               style={{ animationDelay: '0.3s' }}>
//               <div className='p-6 border-b border-border'>
//                 <h3 className='text-xl font-bold mb-2'>Premium</h3>
//                 <div className='flex items-end mb-4'>
//                   <span className='text-4xl font-bold'>$29.99</span>
//                   <span className='text-muted-foreground ml-2 mb-1'>/month</span>
//                 </div>
//                 <p className='text-sm text-muted-foreground'>For career professionals</p>
//               </div>
//               <div className='p-6'>
//                 <ul className='space-y-3'>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>All premium templates</span>
//                   </li>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>Expert ATS optimization</span>
//                   </li>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>Advanced AI content enhancement</span>
//                   </li>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>LinkedIn profile optimization</span>
//                   </li>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>1-on-1 expert resume review</span>
//                   </li>
//                   <li className='flex items-start'>
//                     <Check size={18} className='text-primary mt-0.5 mr-2 flex-shrink-0' />
//                     <span>24/7 priority support</span>
//                   </li>
//                 </ul>
//                 <button className='w-full mt-6 bg-secondary text-secondary-foreground rounded-md px-4 py-3 text-sm font-medium transition-all duration-300 ease-in-out hover:bg-secondary/90'>
//                   Choose Premium
//                 </button>
//               </div>
//             </div>
//           </div>

//           <div className='text-center mt-12 max-w-2xl mx-auto'>
//             <p className='text-muted-foreground mb-6'>
//               All plans include a 7-day free trial. Cancel anytime.
//             </p>
//             <div className='inline-flex items-center justify-center space-x-3 bg-card border border-border rounded-full px-6 py-2'>
//               <span className='text-sm'>Monthly billing</span>
//               <div className='w-10 h-5 bg-primary/20 rounded-full relative flex items-center justify-end p-0.5 cursor-pointer'>
//                 <div className='absolute w-4 h-4 rounded-full bg-primary right-0.5'></div>
//               </div>
//               <span className='text-sm font-medium'>Annual billing (Save 20%)</span>
//             </div>
//           </div>
//         </div>
//         <div className='absolute bottom-0 left-0 w-full h-20 bg-gradient-to-t from-background to-transparent'></div>
//       </section>

//       {/* Final CTA Section */}
//       <section className='py-24 relative overflow-hidden'>
//         <div className='absolute top-0 left-0 w-64 h-64 bg-primary/10 rounded-full filter blur-3xl -z-10 opacity-50 animate-subtlePulse transform -translate-x-1/2 -translate-y-1/2'></div>
//         <div
//           className='absolute bottom-0 right-0 w-96 h-96 bg-primary/5 rounded-full filter blur-3xl -z-10 opacity-50 animate-subtlePulse transform translate-x-1/3 translate-y-1/3'
//           style={{ animationDelay: '2s' }}></div>

//         <div className='container mx-auto px-4 text-center max-w-3xl relative z-10'>
//           <h2 className='text-4xl lg:text-5xl font-bold mb-6'>
//             Ready to Land Your Dream Job?
//           </h2>
//           <p className='text-xl text-muted-foreground mb-10 max-w-2xl mx-auto'>
//             Join thousands of successful job seekers who've created winning resumes with
//             ResumeReady and secured their dream positions.
//           </p>

//           <div
//             className='bg-card border border-border rounded-xl p-8 md:p-12 shadow-md mb-12 transition-all duration-500 ease-in-out hover:shadow-lg hover:border-primary/20 animate-fadeInUp'
//             style={{ animationDelay: '0.3s' }}>
//             <div className='flex flex-col md:flex-row gap-6 items-center justify-between'>
//               <div className='text-left'>
//                 <h3 className='text-2xl font-bold mb-2'>Try Pro Free for 7 Days</h3>
//                 <p className='text-muted-foreground'>
//                   Start with our most popular plan risk-free
//                 </p>
//               </div>
//               <button className='w-full md:w-auto bg-primary text-primary-foreground rounded-md px-8 py-4 text-lg font-medium transition-all duration-300 ease-in-out hover:bg-primary/90 hover:shadow-lg group whitespace-nowrap'>
//                 <span className='flex items-center justify-center'>
//                   Start Free Trial
//                   <ArrowRight
//                     size={18}
//                     className='ml-2 transition-transform duration-300 ease-in-out group-hover:translate-x-1'
//                   />
//                 </span>
//               </button>
//             </div>
//           </div>

//           <div className='flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-muted-foreground'>
//             <div className='flex items-center'>
//               <Check size={16} className='text-primary mr-2' />
//               <span>No credit card required</span>
//             </div>
//             <div className='flex items-center'>
//               <Check size={16} className='text-primary mr-2' />
//               <span>Cancel anytime</span>
//             </div>
//             <div className='flex items-center'>
//               <Check size={16} className='text-primary mr-2' />
//               <span>24/7 customer support</span>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className='py-12 border-t border-border bg-card'>
//         <div className='container mx-auto px-4'>
//           <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12'>
//             <div>
//               <div className='flex items-center space-x-2 mb-4'>
//                 <div className='h-8 w-8 rounded-md bg-primary flex items-center justify-center'>
//                   <span className='text-primary-foreground font-bold text-xs'>RS</span>
//                 </div>
//                 <span className='font-bold text-lg'>ResumeReady</span>
//               </div>
//               <p className='text-sm text-muted-foreground mb-4'>
//                 Create professional, ATS-optimized resumes in minutes with our intelligent
//                 resume builder.
//               </p>
//               <div className='flex space-x-4'>
//                 <a
//                   href='#'
//                   className='text-muted-foreground hover:text-primary transition-colors'
//                   aria-label='Twitter'>
//                   <svg
//                     className='h-5 w-5'
//                     fill='currentColor'
//                     viewBox='0 0 24 24'
//                     aria-hidden='true'>
//                     <path d='M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84' />
//                   </svg>
//                 </a>
//                 <a
//                   href='#'
//                   className='text-muted-foreground hover:text-primary transition-colors'
//                   aria-label='LinkedIn'>
//                   <svg
//                     className='h-5 w-5'
//                     fill='currentColor'
//                     viewBox='0 0 24 24'
//                     aria-hidden='true'>
//                     <path d='M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z' />
//                   </svg>
//                 </a>
//               </div>
//             </div>

//             <div>
//               <h4 className='font-bold mb-4'>Features</h4>
//               <ul className='space-y-3 text-sm'>
//                 <li>
//                   <a
//                     href='#'
//                     className='text-muted-foreground hover:text-primary transition-colors'>
//                     Resume Templates
//                   </a>
//                 </li>
//                 <li>
//                   <a
//                     href='#'
//                     className='text-muted-foreground hover:text-primary transition-colors'>
//                     ATS Optimization
//                   </a>
//                 </li>
//                 <li>
//                   <a
//                     href='#'
//                     className='text-muted-foreground hover:text-primary transition-colors'>
//                     PDF Export
//                   </a>
//                 </li>
//                 <li>
//                   <a
//                     href='#'
//                     className='text-muted-foreground hover:text-primary transition-colors'>
//                     AI Suggestions
//                   </a>
//                 </li>
//                 <li>
//                   <a
//                     href='#'
//                     className='text-muted-foreground hover:text-primary transition-colors'>
//                     Job Search Tips
//                   </a>
//                 </li>
//               </ul>
//             </div>

//             <div>
//               <h4 className='font-bold mb-4'>Company</h4>
//               <ul className='space-y-3 text-sm'>
//                 <li>
//                   <a
//                     href='#'
//                     className='text-muted-foreground hover:text-primary transition-colors'>
//                     About Us
//                   </a>
//                 </li>
//                 <li>
//                   <a
//                     href='#'
//                     className='text-muted-foreground hover:text-primary transition-colors'>
//                     Careers
//                   </a>
//                 </li>
//                 <li>
//                   <a
//                     href='#'
//                     className='text-muted-foreground hover:text-primary transition-colors'>
//                     Privacy Policy
//                   </a>
//                 </li>
//                 <li>
//                   <a
//                     href='#'
//                     className='text-muted-foreground hover:text-primary transition-colors'>
//                     Terms of Service
//                   </a>
//                 </li>
//                 <li>
//                   <a
//                     href='#'
//                     className='text-muted-foreground hover:text-primary transition-colors'>
//                     Contact Us
//                   </a>
//                 </li>
//               </ul>
//             </div>

//             <div>
//               <h4 className='font-bold mb-4'>Get Started</h4>
//               <p className='text-sm text-muted-foreground mb-4'>
//                 Ready to create your professional resume? Try our Pro plan free for 7
//                 days.
//               </p>
//               <button className='w-full bg-primary text-primary-foreground rounded-md px-4 py-3 text-sm font-medium transition-all duration-300 ease-in-out hover:bg-primary/90 hover:shadow-md'>
//                 Start Free Trial
//               </button>
//             </div>
//           </div>

//           <div className='mt-12 pt-8 border-t border-border text-center text-sm text-muted-foreground'>
//             <p>© 2025 ResumeReady. All rights reserved.</p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// // Feature Card Component with refined animations
// const FeatureCard = ({ icon, title, description, color }) => {
//   return (
//     <div className='bg-card border border-border rounded-lg p-8 transition-all duration-500 ease-in-out hover:shadow-md hover:border-primary/20'>
//       <div
//         className={`inline-flex items-center justify-center w-12 h-12 rounded-full ${
//           color ? color + '/10' : 'bg-primary/10'
//         } ${
//           color ? 'text-' + color.replace('bg-', '') : 'text-primary'
//         } mb-4 transition-all duration-300 ease-in-out group-hover:scale-105`}>
//         {icon}
//       </div>
//       <h3 className='text-xl font-semibold mb-2'>{title}</h3>
//       <p className='text-muted-foreground'>{description}</p>
//     </div>
//   );
// };

// // Step Card Component with elegant transitions
// const StepCard = ({ number, title, description, image }) => {
//   return (
//     <div className='relative'>
//       <div className='bg-card border border-border rounded-lg overflow-hidden transition-all duration-500 ease-in-out hover:shadow-md hover:border-primary/20'>
//         <div className='h-40 bg-secondary/20 relative overflow-hidden'>
//           <img
//             src={image}
//             alt={title}
//             className='w-full h-full object-cover transition-transform duration-700 ease-in-out hover:scale-105'
//           />
//           <div className='absolute inset-0 bg-gradient-to-t from-card to-transparent'></div>
//           <div className='absolute top-4 left-4 flex items-center justify-center w-8 h-8 rounded-full bg-primary text-primary-foreground font-bold text-sm'>
//             {number}
//           </div>
//         </div>
//         <div className='p-6'>
//           <h3 className='text-xl font-semibold mb-2'>{title}</h3>
//           <p className='text-muted-foreground'>{description}</p>
//         </div>
//       </div>

//       {number < 3 && (
//         <div className='hidden lg:flex absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-primary/90 rounded-full items-center justify-center shadow-md transition-all duration-300 ease-in-out'>
//           <ChevronRight size={20} className='text-primary-foreground' />
//         </div>
//       )}
//     </div>
//   );
// };

// // Statistics Card Component with subtle animation
// const StatCard = ({ number, label }) => {
//   return (
//     <div className='flex flex-col items-center transition-transform duration-500 ease-in-out hover:translate-y-[-5px]'>
//       <p className='text-3xl font-bold text-primary mb-2'>{number}</p>
//       <p className='text-sm text-muted-foreground'>{label}</p>
//     </div>
//   );
// };

// export default ResumeReadyLanding;

import CustomAnimations from '@/components/landing/CustomAnimations';
import Features from '@/components/landing/Features';
import Footer from '@/components/landing/Footer';
import GridBg from '@/components/landing/GridBg';
import Hero from '@/components/landing/Hero';
import HowItWorks from '@/components/landing/HowItWorks';
import Navbar from '@/components/landing/NavBar';
import Pricing from '@/components/landing/Pricing';
import Testimonials from '@/components/landing/Testimonials';
import { FC, useEffect, useState } from 'react';

const ResumeReadyLanding: FC = () => {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const handleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsScrolled(window.scrollY > 5);
      }, 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className='flex flex-col min-h-screen bg-background text-gray-900 font-sans antialiased'>
      <GridBg />
      <CustomAnimations />
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Features />
      <HowItWorks />
      <Pricing />
      <Testimonials />
      <Footer />
    </div>
  );
};

export default ResumeReadyLanding;
